//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'
import tableGrid from '@/components/tableGrid'
import cellGrid from '@/components/cellGrid'
import { FactoryUtils } from "@/utils/FactoryUtils"
import layer from '@/components/layer/layer.vue'
export default {
    name:'mipLightbox',
    data(){
        return {
            planBScroll:null,
            showFlag:false,
            planDetails:{},
            cell:[],
            data:[
              {
                title:"一、推荐好友购买保险活动",
                list:[
                  {title:'① 活动介绍',content:'在活动页面生成专属链接或专属海报，分享给好友。好友通过分享的页面/海报成功购买「牙齿健康保障计划」，你将获得30元现金奖励。'},
                  {title:'② 奖励提现',content:'推荐好友成功购买，30元奖励金立即到账，进入待生效状态，好友购买后31天后自动释放，可随时提现。'},
                  {title:'③ 活动时间',content:'长期有效'},
                ]
              },
              {
                title:"二、10万奖金瓜分活动",
                list:[
                  {title:'① 活动介绍',content:'扫码入群，限制1000人，人满即止。'},
                  {title:'② 奖励提现',content:'成功推荐2人以上购买「牙齿清洁保障计划」，即可获得参与瓜分10万奖金。'},
                  {title:'③ 活动时间',content:'<span class="yellow">2020.8.15-2020.11.30</span>'},
                ]
              },
              {
                title:"三、排行榜活动",
                list:[
                  {title:'① 活动介绍',content:'成功推荐朋友购买「牙齿清洁保障计划」，即可参与榜单排行挑战活动。'},
                  {title:'② 奖励提现',content:'活动期间，推荐购买「牙齿清洁保障计划」最多的9位，可以获得额外奖金。推荐成功数一致时，更早达成对应单数的用户排名更靠前。具体奖金及规则如下表：',
                    tabledata:{
                      title:['等级','排名','奖金','推荐成功数'],
                      cont:[
                        ['一等奖','1-3名','7万','需>600'],
                        ['二等奖','4-6名','5万','需>300'],
                        ['三等奖','7-9名','3万','需>100']
                      ]
                    },
                  },
                  {title:'③ 活动时间',content:'<span class="yellow">2020.8.15-2020.11.30</span>'},
                ]
              },
              {
                title:"四、条款说明",
                list:[
                  {title:'',content:'参与活动过程中，若存在违反活动规则或恶意刷单等不诚信行为，新氧保有权取消用户奖励金额，并追究其刑事责任。'},
                  {title:'',content:'新氧保有权根据国家法律法规/监管规定/国家政策/市场风险/运营策略及其他不可抗力，调整运营规则或终止本活动，用户继续参与活动，则视为已接受调整新规则。以上所有活动的最终解释权归新氧保所有。'},
                ]
              },
              {
                title:"五、客服咨询",
                list:[
                  {title:'',content:'<span class="yellow">如对本活动有任何疑问，可添加官方小助理微信详细咨询：xinyangbao8888</span>'},
                ]
              }
            ],
            

        }
    },
    components: {
      cellGrid,
      tableGrid,
      layer
    },
    created(){
    },
    methods:{
        // handler(ev){
        //     ev.preventDefault();
        // },
        showToast(){
            this.showFlag = true
            console.log('111',this.planBScroll)
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
            // document.body.addEventListener('touchmove', this.handler, { passive: false });
        },
        close(){
            this.showFlag = false;
            this.$refs.layerRef.removeTouch()
            this.planBScroll = null;
            // document.body.removeEventListener('touchmove', this.handler, { passive: false });
        }
    }
}
